import { CommunicationType, CommunicationTypeEnum } from '@/models'

// TODO: Once the legacy NewMessageTypeModal gets replaced with a typed TS component this map can be deleted.
export const LEGACY_TO_COMMUNICATION_TYPE: Record<string, CommunicationType> = {
  email: CommunicationTypeEnum.enum.Email,
  notification: CommunicationTypeEnum.enum.Notification,
  sms: CommunicationTypeEnum.enum.SMS,
}
